import React, { useEffect, useState } from "react";
import CustomInput from "../../../../components/common/CustomInput/CustomInput";
import CustomTextArea from "../../../../components/common/CustomTextArea/CustomTextArea";
import CustomFileUpload from "../../../../components/common/CustomFileUpload/CustomFileUpload";
import BodyHeader from "../../../../components/common/CommonBodyHeader";
import CustomDropdown from "../../../../components/common/CustomDropdown/CustomDropdown";
import { FieldArray, FormikProvider, useFormik } from "formik";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { addCustomerMasterAsync } from "../../../../redux/features/customerMaster";
import { getFleetMasterDropdownDataAsync } from "../../../../redux/features/fleetMaster";
import { backdropLoadingAction } from "../../../../redux/features/helperSlice";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import RouteNames from "../../../../AppRoutes/RouteName";
import validation from "../../../../helpers/validation";
import CustomDatePicker from "../../../../components/common/CustomDatePicker/CustomDatePicker";
import { getRouteData } from "../../../geo-location/routeHelper";

const validationSchema = Yup.object().shape({
   customerName: validation.name("Customer Name"),
   gstNumber: validation.gstNumber.notRequired(),
   panNumber: Yup.string().required("PAN number is required"),

   productType: Yup.string().required("Product Type is required"),
   contactPerson: Yup.array().of(
      Yup.object().shape({
         name: validation.name("Contact Person Name"),
         mobile: validation.mobile,
      }),
   ),
   address: Yup.array().of(validation.address()),
   lane: Yup.array().of(
      Yup.object().shape({
      }),
   ),
});

const initialValues = {
   customerName: "",
   gstNumber: "",
   panNumber: "",

   agreementDetails: [{ startDate: null, endDate: null, agreementDocument: null }],
   contactPerson: [
      {
         name: "",
         mobile: "",
         email: "",
      },
   ],

   productType: "",
   productTypeOtherValue: "",

   location: [""],
   address: [""],
   lane: [
      {
         // laneName: "",
         origin_label: "",
         destination_label: "",
         origin: "",
         destination: "",
         vehicleType: "",
         tonnage: "",
         distanceKm: "",
         durationMin: "",
      },
   ],
};

export default function CustomerMasterAdd() {
   const navigate = useNavigate();
   const dispatch = useDispatch();

   const fleetMaster = useSelector((state) => state.fleetMaster);
   const [isFetchingRoute, setIsFetchingRoute] = useState(false);

   const locationData = fleetMaster?.location?.map?.((item) => ({
      label: item?.name,
      value: item?.id,
   }));

   const productType = ["LPG", "Petrol", "Diesel", "Ethanol", "Lubricant", "Other"].map(
      (item) => ({
         label: item,
         value: item,
      }),
   );

   // const vehicleTypeData = fleetMaster?.vehicleCategory?.map?.((item) => ({
   //    label: item?.category_name,
   //    value: item?.id,
   // }));

   // const tonnageData = Object.values(fleetMaster?.tonnage)?.map((item) => ({
   //    label: item?.tonnage,
   //    value: item?.id,
   // }));

   useEffect(() => {
      dispatch(getFleetMasterDropdownDataAsync());
   }, []);

   const handleAddCustomerMaster = (formData) => {
      const newData = new FormData();

      // Append basic information
      newData.append("name", formData?.customerName);
      newData.append("gst_number", formData?.gstNumber);
      newData.append("pan_number", formData?.panNumber);
      newData.append("vehicle_category", formData?.vehicle_category);
      newData.append("product_type", formData?.productType);
      newData.append("other_value", formData?.productTypeOtherValue);
      newData.append("model_id", 6);
      newData.append("action_id", 1);

      // Prepare data for the request
      const data = {
         location_master_id: formData?.location?.map?.((item) => +item),
         address: formData.address,
         contact_person_name: formData?.contactPerson?.map?.((item) => item?.name),
         mobile: formData?.contactPerson?.map?.((item) => item?.mobile),
         email: formData?.contactPerson?.map?.((item) => item?.email),
         //lane_name: formData?.lane?.map?.((item) => item?.laneName),
         origin: formData?.lane?.map?.((item) => +item?.origin),
         destination: formData?.lane?.map?.((item) => +item?.destination),

         distanceKm: formData?.lane?.map?.((item) => +item?.distanceKm),
         durationMin: formData?.lane?.map?.((item) => +"" + item?.durationMin),

         vehicle_category_id: formData?.lane?.map?.((item) => +item?.vehicleType),
         tonnage_id: formData?.lane?.map?.((item) => +item?.tonnage),
         // cust_express_mode_rate_additional: formData?.lane?.map?.(
         //    (item) => +item?.expressModeRateAdditional
         // ),
         // cust_super_express_mode_rate_additional: formData?.lane?.map?.(
         //    (item) => +item?.superExpressModeRateAdditional
         // ),
         // cust_detention_rate_additional: formData?.lane?.map?.(
         //    (item) => +item?.detentionRateAdditional
         // ),
         // cust_multiple_loading_location_rate_additional: formData?.lane?.map?.(
         //    (item) => +item?.multipleLoadingLocationRateAdditional
         // ),
         // cust_loading_charges: formData?.lane?.map?.((item) => +item?.loadingCharges),
         // cust_miscellaneous_charges: formData?.lane?.map?.(
         //    (item) => +item?.miscellaneousCharges
         // ),
         // cust_brokerage_charges: formData?.lane?.map?.((item) => +item?.brokerageCharges),
         // cust_unloading_charge: formData?.lane?.map?.((item) => +item?.unloadingCharge),
         // cust_miscellaneous_remarks: formData?.lane?.map?.(
         //    (item) => item?.miscellaneousRemarks
         // ),
         // cust_multiple_unloading_location_rate_additional: formData?.lane?.map?.(
         //    (item) => +item?.multipleUnloadingLocationRateAdditional
         // ),
         // cust_trip_rate: formData?.lane?.map?.((item) => +item?.tripRate),

         // // New fields
         // diesel_rate: formData?.lane?.map?.((item) => +item?.dieselRate),
         // adblue_rate: formData?.lane?.map?.((item) => +item?.adblueRate),
         // trip_advance: formData?.lane?.map?.((item) => +item?.tripAdvance),
         // miscellaneous_rate: formData?.lane?.map?.((item) => +item?.miscellaneousRate),
      };

      const agreementStartDate = formData?.agreementDetails?.map?.(
         (item) => item?.startDate ?? null,
      );
      const agreementEndDate = formData?.agreementDetails?.map?.(
         (item) => item?.endDate ?? null,
      );

      // Append files to FormData
      formData?.agreementDetails?.forEach?.((item) => {
         newData.append("agreement_document[]", item?.agreementDocument);
      });
      newData.append("start_date[]", agreementStartDate);
      newData.append("end_date[]", agreementEndDate);

      // Append all other data
      Object.keys(data).forEach((key) => {
         data[key]?.forEach((value) => {
            newData.append(`${key}[]`, value);
         });
      });

      // Dispatch action with the FormData
      dispatch(backdropLoadingAction(true));
      dispatch(
         addCustomerMasterAsync({
            data: newData,
            err: () => {
               //toast.error("Something went wrong !");
               dispatch(backdropLoadingAction(false));
            },
            done: () => {
               toast.success("Customer master created successfully !");
               dispatch(backdropLoadingAction(false));
               navigate(RouteNames.customerMasterView);
            },
         }),
      );
   };

   const formik = useFormik({
      initialValues: initialValues,
      validationSchema: validationSchema,
      onSubmit: handleAddCustomerMaster,
   });

   const {
      touched,
      errors,
      values,
      getFieldProps,
      handleSubmit,
      setFieldValue,
   } = formik;

   const [lanes, setLanes] = useState([
      {
         customerName: "",
         origin: "",
         destination: "",
         vehicleType: "",
         cubicLitre: "",
         origin_label: "",
         destination_label: "",
         distanceKm: "",
         durationMin: "",
      },
   ]);

   // Add new lane row
   const handleAddLane = () => {
      setLanes([
         ...lanes,
         {
            customerName: "",
            origin: "",
            destination: "",
            vehicleType: "",
            cubicLitre: "",
            origin_label: "",
            destination_label: "",
            distanceKm: "",
            durationMin: "",
         },
      ]);
   };

   // Remove a lane row
   const handleRemoveLane = (index) => {
      setLanes(lanes.filter((_, i) => i !== index));
   };

   // Handle input change
   const handleChange = (index, field, value) => {
      const updatedLanes = [...lanes];
      updatedLanes[index][field] = value;
      setLanes(updatedLanes);
   };

   const handleLocationChange = async (index, originLabel, destinationLabel) => {
      if (!originLabel || !destinationLabel) return;

      try {
         setIsFetchingRoute(true); // disable submit button

         const routeData = await getRouteData(originLabel, destinationLabel);
         if (routeData) {
            setFieldValue(`lane[${index}].distanceKm`, routeData.distanceKm);
            setFieldValue(`lane[${index}].durationMin`, routeData.durationMin);
            setIsFetchingRoute(false);
         } else {
            setFieldValue(`lane[${index}].distanceKm`, 0);
            setFieldValue(`lane[${index}].durationMin`, 0);
            setIsFetchingRoute(false);
         }
      } catch (error) {
         console.error("Error fetching route:", error);
      } finally {
         setIsFetchingRoute(false); // re-enable after done
      }
   };

   return (
      <FormikProvider value={formik}>
         <div>
            <BodyHeader title="Add Customer Master" />
            {/* <form className="p-3 shadow-lg" onSubmit={formik.handleSubmit}> */}
            <div className="p-3 shadow-lg">
               <div className="card card-primary">
                  <div className="card-header">
                     <h3 className="card-title">Customer Documents</h3>
                  </div>
                  <div className="card-body">
                     <div className="row">
                        <div className="col-lg-4">
                           <CustomInput
                              require
                              label="Customer Name"
                              id="customerName"
                              placeholder="Enter Customer Name"
                              {...getFieldProps("customerName")}
                              errors={
                                 Boolean(touched.customerName) &&
                                 Boolean(errors.customerName)
                              }
                              message={errors.customerName}
                           />
                        </div>
                        <div className="col-lg-4">
                           <CustomInput
                              label="GST Number"
                              id="gstNumber"
                              name="gstNumber"
                              placeholder="Enter GST Number"
                              {...getFieldProps(`gstNumber`)}
                              errors={
                                 Boolean(touched.gstNumber) && Boolean(errors.gstNumber)
                              }
                              message={errors.gstNumber}
                           />
                        </div>

                        <div className="col-lg-4">
                           <CustomInput
                              require
                              label="Pan Number"
                              id="panNumber"
                              name="panNumber"
                              placeholder="Enter PAN Number"
                              {...getFieldProps(`panNumber`)}
                              errors={
                                 Boolean(touched.panNumber) && Boolean(errors.panNumber)
                              }
                              message={errors.panNumber}
                           />
                        </div>

                        <div className="col-lg-4">
                           <CustomDropdown
                              require
                              optionData={productType}
                              label="Product Type"
                              onChange={(value) => {
                                 setFieldValue("productType", value?.[0]?.value);
                              }}
                              errors={
                                 Boolean(touched.productType) &&
                                 Boolean(errors.productType)
                              }
                              message={errors.productType}
                           />
                        </div>

                        {values.productType === "Other" && (
                           <div className="col-lg-4">
                              <CustomInput
                                 label="Other Value"
                                 name="productTypeOtherValue"
                                 id="productTypeOtherValue"
                                 {...getFieldProps(`productTypeOtherValue`)}
                                 errors={
                                    Boolean(touched.productTypeOtherValue) &&
                                    Boolean(errors.productTypeOtherValue)
                                 }
                                 message={errors.productTypeOtherValue}
                              />
                           </div>
                        )}

                        {/* Contact Person Details  */}
                        <div className="col-lg-12">
                           <FieldArray
                              name="contactPerson"
                              render={(arrayHelpers) => (
                                 <div>
                                    {values.contactPerson.map((item, index) => (
                                       <div
                                          className={
                                             index < values.contactPerson.length - 1 &&
                                                values.contactPerson.length > 1
                                                ? "row border-bottom mb-4 pb-3"
                                                : "row"
                                          }
                                       >
                                          <div className="col-lg-4">
                                             <CustomInput
                                                require
                                                label="Contact Person Name"
                                                id="contactPersonName"
                                                placeholder="Enter Contact Person Name"
                                                {...getFieldProps(
                                                   `contactPerson[${index}].name`,
                                                )}
                                                errors={
                                                   Boolean(
                                                      touched.contactPerson?.[index]
                                                         ?.name,
                                                   ) &&
                                                   Boolean(
                                                      errors.contactPerson?.[index]?.name,
                                                   )
                                                }
                                                message={
                                                   errors.contactPerson?.[index]?.name
                                                }
                                             />
                                          </div>
                                          <div className="col-lg-4">
                                             <CustomInput
                                                require
                                                label="Customer Mobile No"
                                                id="customerMobileNo"
                                                placeholder="Enter Customer Mobile No"
                                                {...getFieldProps(
                                                   `contactPerson[${index}].mobile`,
                                                )}
                                                maxLength={10}
                                                errors={
                                                   Boolean(
                                                      touched.contactPerson?.[index]
                                                         ?.mobile,
                                                   ) &&
                                                   Boolean(
                                                      errors.contactPerson?.[index]
                                                         ?.mobile,
                                                   )
                                                }
                                                message={
                                                   errors.contactPerson?.[index]?.mobile
                                                }
                                             />
                                          </div>
                                          <div className="col-lg-4">
                                             <CustomInput
                                                label="Customer Email Id"
                                                id="customerEmailId"
                                                placeholder="Enter Customer Email Id"
                                                {...getFieldProps(
                                                   `contactPerson[${index}].email`,
                                                )}
                                                errors={
                                                   Boolean(
                                                      touched.contactPerson?.[index]
                                                         ?.email,
                                                   ) &&
                                                   Boolean(
                                                      errors.contactPerson?.[index]
                                                         ?.email,
                                                   )
                                                }
                                                message={
                                                   errors.contactPerson?.[index]?.email
                                                }
                                             />
                                          </div>
                                          <div className="col-12">
                                             {values.contactPerson.length > 1 &&
                                                index !== 0 && (
                                                   <button
                                                      type="button"
                                                      className="btn btn-danger float-right mr-3"
                                                      onClick={() => {
                                                         arrayHelpers.remove(index);
                                                      }}
                                                   >
                                                      <i className="fas fa-trash"></i>{" "}
                                                      Delete
                                                   </button>
                                                )}
                                          </div>
                                       </div>
                                    ))}
                                 </div>
                              )}
                           />
                        </div>

                        <div className="col-lg-6">
                           {/* Location  */}
                           <div className="">
                              <FieldArray
                                 name="location"
                                 render={(arrayHelpers) => (
                                    <div>
                                       {values.location.map((item, index) => (
                                          <div key={index}>
                                             <CustomDropdown
                                                optionData={locationData}
                                                label="Location"
                                                id=""
                                                onChange={(values) => {
                                                   setFieldValue(
                                                      `location[${index}]`,
                                                      values?.[0]?.value,
                                                   );
                                                }}
                                                errors={
                                                   Boolean(touched.location?.[index]) &&
                                                   Boolean(errors.location?.[index])
                                                }
                                                message={errors.location?.[index]}
                                             />
                                             {values.location.length > 1 &&
                                                index !== 0 && (
                                                   <button
                                                      type="button"
                                                      className="btn btn-danger float-right mb-3"
                                                      onClick={() => {
                                                         arrayHelpers.remove(index);
                                                      }}
                                                   >
                                                      <i className="fas fa-trash"></i>{" "}
                                                      Delete Location
                                                   </button>
                                                )}
                                          </div>
                                       ))}
                                    </div>
                                 )}
                              />
                           </div>
                        </div>

                        <div className="col-lg-6">
                           {/* Address  */}
                           <div className="d-block">
                              <FieldArray
                                 name="address"
                                 render={(arrayHelpers) => (
                                    <div>
                                       {values.address.map((item, index) => (
                                          <>
                                             <CustomTextArea
                                                label="Address"
                                                id=""
                                                placeholder="Enter Address "
                                                {...getFieldProps(`address[${index}]`)}
                                                errors={
                                                   Boolean(touched.address?.[index]) &&
                                                   Boolean(errors.address?.[index])
                                                }
                                                message={errors.address?.[index]}
                                             />
                                             {values.address.length > 1 &&
                                                index !== 0 && (
                                                   <button
                                                      type="button"
                                                      className="btn btn-danger float-right mb-3"
                                                      onClick={() => {
                                                         arrayHelpers.remove(index);
                                                      }}
                                                   >
                                                      <i className="fas fa-trash"></i>{" "}
                                                      Delete Address
                                                   </button>
                                                )}
                                          </>
                                       ))}
                                    </div>
                                 )}
                              />
                           </div>
                        </div>

                        <div className="col-12 mt-4">
                           <button
                              type="button"
                              className="btn mx-1 btn-primary"
                              onClick={() => {
                                 setFieldValue("contactPerson", [
                                    ...values.contactPerson,
                                    {
                                       name: "",
                                       mobile: "",
                                       email: "",
                                    },
                                 ]);
                              }}
                           >
                              <i className="fas fa-plus"></i> Add Contact Person
                           </button>
                           <button
                              type="button"
                              className="btn mx-1 btn-primary"
                              onClick={() => {
                                 setFieldValue("address", [...values.address, ""]);
                              }}
                           >
                              <i className="fas fa-plus"></i> Add Address
                           </button>
                           <button
                              type="button"
                              className="btn mx-1 btn-primary"
                              onClick={() => {
                                 setFieldValue("location", [...values.location, ""]);
                              }}
                           >
                              <i className="fas fa-plus"></i> Add Location
                           </button>
                        </div>
                     </div>
                  </div>
               </div>

               <div className="row">
                  <div className="col-lg-12">
                     <div className="card card-primary">
                        <div className="card-header">
                           <h3 className="card-title">Agreement Details</h3>
                        </div>
                        <div className="card-body row">
                           <div className="col-lg-12">
                              <FieldArray
                                 name="agreementDetails"
                                 render={(arrayHelpers) => (
                                    <div>
                                       {values?.agreementDetails?.map?.((item, index) => {
                                          return (
                                             <div className="row" key={index}>
                                                <div className="col-lg-4" key={index}>
                                                   <CustomFileUpload
                                                      label="Agreement Document"
                                                      {...getFieldProps(
                                                         `agreementDetails[${index}].agreementDocument`,
                                                      )}
                                                      onChange={(event, file) =>
                                                         setFieldValue(
                                                            `agreementDetails[${index}].agreementDocument`,
                                                            file,
                                                         )
                                                      }
                                                      errors={
                                                         Boolean(
                                                            touched.agreementDetails?.[
                                                               index
                                                            ]?.agreementDocument,
                                                         ) &&
                                                         Boolean(
                                                            errors.agreementDetails?.[
                                                               index
                                                            ]?.agreementDocument,
                                                         )
                                                      }
                                                      message={
                                                         errors.agreementDetails?.[index]
                                                            ?.agreementDocument
                                                      }
                                                   />
                                                </div>
                                                <div className="col-lg-3">
                                                   <CustomDatePicker
                                                      label="Start date"
                                                      placeholder="Start date"
                                                      {...getFieldProps(
                                                         `agreementDetails[${index}].startDate`,
                                                      )}
                                                      errors={
                                                         Boolean(
                                                            touched.agreementDetails?.[
                                                               index
                                                            ]?.startDate,
                                                         ) &&
                                                         Boolean(
                                                            errors.agreementDetails?.[
                                                               index
                                                            ]?.startDate,
                                                         )
                                                      }
                                                      message={
                                                         errors.agreementDetails?.[index]
                                                            ?.startDate
                                                      }
                                                   />
                                                </div>
                                                <div className="col-lg-3">
                                                   <CustomDatePicker
                                                      label="End date"
                                                      placeholder="End date"
                                                      {...getFieldProps(
                                                         `agreementDetails[${index}].endDate`,
                                                      )}
                                                      errors={
                                                         Boolean(
                                                            touched.agreementDetails?.[
                                                               index
                                                            ]?.endDate,
                                                         ) &&
                                                         Boolean(
                                                            errors.agreementDetails?.[
                                                               index
                                                            ]?.endDate,
                                                         )
                                                      }
                                                      message={
                                                         errors.agreementDetails?.[index]
                                                            ?.endDate
                                                      }
                                                   />
                                                </div>
                                                {values.agreementDetails.length > 1 && (
                                                   <div className="col-lg-2 mt-4 pt-2">
                                                      <button
                                                         type="button"
                                                         className="btn btn-danger"
                                                         onClick={() => {
                                                            arrayHelpers.remove(index);
                                                         }}
                                                      >
                                                         <i className="fas fa-trash"></i>{" "}
                                                         Delete
                                                      </button>
                                                   </div>
                                                )}
                                             </div>
                                          );
                                       })}
                                    </div>
                                 )}
                              />
                           </div>
                           <div className="my-2">
                              <button
                                 type="button"
                                 className="btn mx-1 btn-primary"
                                 onClick={() => {
                                    setFieldValue("agreementDetails", [
                                       ...values.agreementDetails,
                                       {
                                          startDate: "",
                                          endDate: "",
                                          agreementDocument: null,
                                       },
                                    ]);
                                 }}
                              >
                                 <i className="fas fa-plus"></i> Add Agreement Document
                              </button>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
               {/* 
               <div className="card card-primary">
                  <div className="card-header">
                     <h3 className="card-title">Lane Details</h3>
                  </div>

                  <div className="card-body">
                     {lanes.map((lane, index) => (
                        <div className="row mb-3" key={index}>
                           <div className="col-md-3">
                              <CustomInput
                                 require
                                 label="Customer Name"
                                 id="laneCustomerName"
                                 placeholder="Customer Name"
                                 disabled={true}
                                 onChange={(event) => {}}
                                 value={formik.values.customerName}
                              />
                           </div>

                           <div className="col-md-2">
                              <CustomDropdown
                                 label="Origin"
                                 require
                                 optionData={locationData}
                                 onChange={(values) => {
                                    const label = values?.[0]?.label;
                                    const val = values?.[0]?.value;

                                    setFieldValue(`lane[${index}].origin`, val);
                                    setFieldValue(`lane[${index}].origin_label`, label);

                                    // Get the current destination label from Formik
                                    const destinationLabel =
                                       formik.values.lane[index]?.destination_label;

                                    // Only call when both locations are selected
                                    if (label && destinationLabel) {
                                       handleLocationChange(
                                          index,
                                          label,
                                          destinationLabel
                                       );
                                    }
                                 }}
                                 errors={
                                    Boolean(touched.lane?.[index]?.origin) &&
                                    Boolean(errors.lane?.[index]?.origin)
                                 }
                                 message={errors.lane?.[index]?.origin}
                              />
                           </div>

                           <div className="col-md-2">
                              <CustomDropdown
                                 label="Destination"
                                 require
                                 optionData={locationData}
                                 values={formik.values.destination}
                                 onChange={(values) => {
                                    const label = values?.[0]?.label;
                                    const val = values?.[0]?.value;

                                    setFieldValue(`lane[${index}].destination`, val);
                                    setFieldValue(
                                       `lane[${index}].destination_label`,
                                       label
                                    );

                                    const originLabel =
                                       formik.values.lane[index]?.origin_label;

                                    // Only call when both locations are selected
                                    if (originLabel && label) {
                                       handleLocationChange(index, originLabel, label);
                                    }
                                 }}
                                 errors={
                                    Boolean(touched.lane?.[index]?.destination) &&
                                    Boolean(errors.lane?.[index]?.destination)
                                 }
                                 message={errors.lane?.[index]?.destination}
                              />
                           </div>

                           <CustomInput
                              inputType="hidden"
                              placeholder="distanceKm"
                              value={values?.lane?.[index]?.distanceKm || "0"}
                              readOnly
                           />
                           <CustomInput
                              inputType="hidden"
                              placeholder="durationMin"
                              value={values?.lane?.[index]?.durationMin || "0"}
                              readOnly
                           />

                           <div className="col-md-2">
                              <CustomDropdown
                                 label="Vehicle Type"
                                 require
                                 optionData={vehicleTypeData}
                                 values={formik.values.vehicleCategory}
                                 onChange={(values) => {
                                    setFieldValue(
                                       `lane[${index}].vehicleType`,
                                       values?.[0]?.value
                                    );
                                 }}
                                 errors={
                                    Boolean(touched.lane?.[index]?.vehicleType) &&
                                    Boolean(errors.lane?.[index]?.vehicleType)
                                 }
                                 message={errors.lane?.[index]?.vehicleType}
                              />
                           </div>

                           <div className="col-md-2">
                              <CustomDropdown
                                 label="Cubic Litre"
                                 require
                                 optionData={tonnageData}
                                 values={formik.values.tonnage}
                                 onChange={(values) => {
                                    setFieldValue(
                                       `lane[${index}].tonnage`,
                                       values?.[0]?.value
                                    );
                                 }}
                                 errors={
                                    Boolean(touched.lane?.[index]?.tonnage) &&
                                    Boolean(errors.lane?.[index]?.tonnage)
                                 }
                                 message={errors.lane?.[index]?.tonnage}
                              />
                           </div>

                           <div className="col-md-1 d-flex justify-content-center align-items-center">
                              {lanes.length > 1 && (
                                 <button
                                    type="button"
                                    className="btn btn-danger btn-sm"
                                    style={{
                                       height: "38px",
                                       width: "50px",
                                       padding: "0",
                                       marginTop: "15px",
                                    }}
                                    onClick={() => handleRemoveLane(index)}
                                 >
                                    {" "}
                                    ✕{" "}
                                 </button>
                              )}
                           </div>
                        </div>
                     ))}

                     <button
                        type="button"
                        className="btn btn-primary mt-2"
                        onClick={handleAddLane}
                     >
                        + Add Lane
                     </button>
                  </div>
               </div> */}

               <div className="col-12 mt-3 text-center">
                  <button
                     className="btn btn-primary px-4 py-3"
                     type="submit"
                     onClick={handleSubmit}
                     disabled={isFetchingRoute || formik.isSubmitting}
                  >
                     <h6 className="mb-0 text-uppercase">Submit</h6>
                  </button>
                  {/* <button className="btn btn-danger ml-3 px-4 py-3" type="submit">
                     <h6 className="mb-0 text-uppercase">reset</h6>
                  </button> */}
               </div>
            </div>
         </div>
      </FormikProvider>
   );
}

function getlabelsFromDropdownData(id, data) {
   const label = data?.filter?.((item) => item.value === id)?.[0]?.label;
   return label;
}
